import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
    constructor(@Inject(PLATFORM_ID) private platformId: object) {
        super();
    }

    override parse(url: string): UrlTree {
        // Al router de Angular siempre se le pasa la versión SIN barra para que el match interno no falle
        const matchUrl =
            url.length > 1 && url.endsWith('/') ? url.slice(0, -1) : url;
        return super.parse(matchUrl);
    }

    override serialize(tree: UrlTree): string {
        let out = super.serialize(tree);
        const needs = environment.trailingSlash;

        if (!needs) {
            if (out.length > 1 && out.endsWith('/')) {
                return out.slice(0, -1);
            }
            return out;
        }

        // Evitar modificar la raíz
        if (out === '/') return out;

        // Separar la ruta principal de los query params (?) o fragmentos (#)
        const queryIndex = out.indexOf('?');
        const fragmentIndex = out.indexOf('#');

        let splitIndex = -1;
        if (queryIndex !== -1 && fragmentIndex !== -1) {
            splitIndex = Math.min(queryIndex, fragmentIndex);
        } else if (queryIndex !== -1) {
            splitIndex = queryIndex;
        } else if (fragmentIndex !== -1) {
            splitIndex = fragmentIndex;
        }

        let path = splitIndex > -1 ? out.substring(0, splitIndex) : out;
        const suffix = splitIndex > -1 ? out.substring(splitIndex) : '';

        // Añadir la barra solo a la ruta base si no la tiene
        if (path !== '/' && !path.endsWith('/')) {
            path += '/';
        }

        return path + suffix;
    }
}
